import React from 'react';
import { Box } from '@mui/material';
import FavoriteMovies from '../components/FavouriteMovies';

const FavoritesPage = () => {
  return (
    <Box>
      <FavoriteMovies />
    </Box>
  );
};

export default FavoritesPage;